export default __webpack_public_path__ + "static/media/room-container.4c70cae4.jpg";